import React from 'react';

// Keep rendering failures visible without deleting drafts, cart items or preferences.
export default class AppErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  componentDidMount() { window.dispatchEvent(new Event('minimural:mounted')); }

  reload = event => {
    event.preventDefault();
    const url = new URL(window.location.href);
    url.searchParams.set('_retry', Date.now().toString());
    window.location.replace(url.href);
  };

  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="mm-startup" role="alert"><div className="mm-startup-card">
      <strong className="mm-startup-brand">MINI MURAL ♥</strong>
      <h1>Let’s try that again.</h1>
      <p>Something interrupted this page. Please reload to try again.</p>
      <p>页面显示遇到问题，请重新加载。</p>
      <div className="mm-startup-actions"><a href="" onClick={this.reload}>Reload / 重新加载</a><a href="/">Home / 首页</a></div>
      <small>Reloading does not clear your saved designs.<br/>重新加载不会清除已保存的设计。<br/>MM-RENDER</small>
    </div></main>;
  }
}
